import axios from "axios"
import { APIURL } from "../Constantes"
import { getCabecera } from "../utils/getCabecera"
import { getError } from "../utils/errors";
const urlPurchase = "Purchase"

export const getComprasCotizacion = async ({ IdCotizacion }) => {
    return axios.get(`${APIURL}/${urlPurchase}/find/${IdCotizacion}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}
export const getComprasItemsPaquete = async ({ IdPaquete }) => {
    return axios.get(`${APIURL}/${urlPurchase}/items/${IdPaquete}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}

export const newCompraItem = async ({ idTipoCompra, idPaquete, idCuenta, idMoneda, MontoProveedor, FechaRegreso }) => {
    return axios.post(`${APIURL}/${urlPurchase}/reserve`,
        {
            idTipoCompra,
            idPaquete,
            idCuenta,
            idMoneda,
            MontoProveedor,
            FechaRegreso,
        },
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response;
        }).catch((Error) => {
            return getError(Error)
        })
}
// * POST/api/Purchase/Liquidation/payGroup/Amount
//* Generar la compra para item liquidación
export const newCompraItemGrupalLiquidacionAmount = async (
    {
        idTipoCompra,
        ClaveViaje,
        CostoUnitarioAdulto,
        CostoUnitarioMenor,
        CostoUnitarioInfante,
        CostoUnitarioSencilla,
        CostoUnitarioTriple,
        CostoUnitarioCuadruple,
        IdMoneda
    }) => {
    return axios.post(`${APIURL}/${urlPurchase}/Liquidation/payGroup/Amount`,
        {
            "idTipoCompra": idTipoCompra,
            "ClaveViaje": ClaveViaje,
            "CostoUnitarioAdulto": CostoUnitarioAdulto,
            "CostoUnitarioMenor": CostoUnitarioMenor,
            "CostoUnitarioInfante": CostoUnitarioInfante,
            "CostoUnitarioSencilla": CostoUnitarioSencilla,
            "CostoUnitarioTriple": CostoUnitarioTriple,
            "CostoUnitarioCuadruple": CostoUnitarioCuadruple,
            "IdMoneda": IdMoneda

        },
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response;
        }).catch((Error) => {
            return getError(Error)
        })
}
// *POST /api/Purchase/Liquidation/payGroup
//* Generar la compra para item liquidación
export const newCompraItemGrupalLiquidacion = async (
    {
        idTipoCompra,
        ClaveViaje,
        CostoUnitarioAdulto,
        CostoUnitarioMenor,
        CostoUnitarioInfante,
        CostoUnitarioSencilla,
        CostoUnitarioTriple,
        CostoUnitarioCuadruple,
        IdMoneda
    }) => {
    return axios.post(`${APIURL}/${urlPurchase}/Liquidation/payGroup`,
        {
            "idTipoCompra": idTipoCompra,
            "ClaveViaje": ClaveViaje,
            "CostoUnitarioAdulto": CostoUnitarioAdulto,
            "CostoUnitarioMenor": CostoUnitarioMenor,
            "CostoUnitarioInfante": CostoUnitarioInfante,
            "CostoUnitarioSencilla": CostoUnitarioSencilla,
            "CostoUnitarioTriple": CostoUnitarioTriple,
            "CostoUnitarioCuadruple": CostoUnitarioCuadruple,
            "IdMoneda": IdMoneda

        },
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response;
        }).catch((Error) => {
            return getError(Error)
        })
}
//* Generar la compra para item Aereo
export const newCompraItemGrupal = async ({ idTipoCompra, ClaveViaje, CostoUnitarioAdulto, CostoUnitarioMenor, CostoUnitarioInfante, IdMoneda }) => {
    return axios.post(`${APIURL}/${urlPurchase}/payGroup`,
        {
            idTipoCompra,
            ClaveViaje,
            CostoUnitarioAdulto,
            CostoUnitarioMenor,
            CostoUnitarioInfante,
            IdMoneda
        },
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response;
        }).catch((Error) => {
            return getError(Error)
        })
}
export const newItemPagoGrupal = async ({ idTipoCompra, ClaveViaje, CostoUnitarioAdulto, CostoUnitarioMenor, CostoUnitarioInfante, IdMoneda }) => {
    return axios.post(`${APIURL}/${urlPurchase}/payGroup`,
        {
            idTipoCompra,
            ClaveViaje,
            CostoUnitarioAdulto,
            CostoUnitarioMenor,
            CostoUnitarioInfante,
            IdMoneda,
        },
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response;
        }).catch((Error) => {
            return getError(Error);
        })
}
export const deleteCompraItem = async ({ idCompra }) => {
    return axios.delete(`${APIURL}/${urlPurchase}/DeleteItem/${idCompra}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return { status: 500 };
        })
}

export const updateCompraItem = async ({ idCompra, idMoneda, MontoProveedor }) => {
    return axios.put(`${APIURL}/${urlPurchase}/item/${idCompra}`,
        {
            idMoneda,
            MontoProveedor
        },
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return { status: 500 };
        })
}
// export const getItemsPagarGrupo = async ({ idTpoCompra, nombrePaquete, fechaViaje }) => {
//     return axios.get(`${APIURL}/${urlPurchase}/items/${idTpoCompra}/payGroup/${nombrePaquete}/${fechaViaje}`,
//     {
//         headers: getCabecera()
//     }).then((Response) => {
//         return Response.data;
//     }).catch((Error) => {
//         return { };
//     })
// }
export const getItemsPagarGrupo = async ({ idTpoCompra, ClaveViaje }) => {
    return axios.get(`${APIURL}/${urlPurchase}/items/${idTpoCompra}/payGroup/${ClaveViaje}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return {};
        })
}
//* Enviar compra a finanzas por parte del agente Reserva y Extras
export const updateAutorizacionCompraItem = async ({ idCompra }) => {
    return axios.put(`${APIURL}/${urlPurchase}/item/authorizedAgent/${idCompra}`,
        {
        },
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return { status: 500 };
        })
}
//Todo: Servicios finanzas
export const getComprasIndividual = async () => {
    return axios.get(`${APIURL}/${urlPurchase}/items/authorized`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}
export const getComprasHistorico = async ({ fecha }) => {
    return axios.get(`${APIURL}/${urlPurchase}/items/paidOut/${fecha}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return {};
        })
}
export const getComprasGrupalHistorico = async ({ fecha }) => {
    return axios.get(`${APIURL}/${urlPurchase}/items/paidOut/group/${fecha}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return {};
        })
}
export const putPagarCompraIndividual = async ({ idCompra, TipoCambio, fechaPago }) => {
    return axios.put(`${APIURL}/${urlPurchase}/item/paidOut/${idCompra}`,
        {
            TipoCambio,
            FechaPago: fechaPago
        },
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return getError(Error)
        })
}
export const getPagosAutorizadosGrupal = async () => {
    return axios.get(`${APIURL}/${urlPurchase}/items/authorized/group`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}
export const putPagarCompraGrupal = async ({ idPagoGrupal, TipoCambio }) => {
    return axios.put(`${APIURL}/${urlPurchase}/item/paidOut/group/${idPagoGrupal}`,
        {
            TipoCambio
        },
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return getError(Error);
            // return { status: 500 };
        })
}
export const getItemsUtilidad = async ({ fecha }) => {
    return axios.get(`${APIURL}/${urlPurchase}/items/Collected/Util/${fecha}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}

export const deleteCancelarCompra = async ({ idCompra }) => {
    return axios.delete(`${APIURL}/${urlPurchase}/item/Cancel/${idCompra}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return getError(Error);
            // return { status: 500 };
        })
}
export const deleteCancelarCompraGrupal = async ({ idPagoGrupal }) => {
    return axios.delete(`${APIURL}/${urlPurchase}/item/Cancel/Group/${idPagoGrupal}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return getError(Error);
            // return { status: 500 };
        })
}
export const getDetallePagoGrupal = async ({ IdPagoGrupal }) => {
    return axios.get(`${APIURL}/${urlPurchase}/items/details/payGroup/${IdPagoGrupal}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}
//* Pagar extra agente modulo extras 
//* POST /api/Purchase/Extra
export const postCrearItemExtra = async ({ idPaquete, idCuenta, idMoneda, MontoProveedor, IdExtra }) => {
    return axios.post(`${APIURL}/${urlPurchase}/Extra`,
        {
            "idPaquete": idPaquete,
            "idCuenta": idCuenta,
            "idMoneda": idMoneda,
            "MontoProveedor": MontoProveedor,
            "IdExtra": IdExtra
        },
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return getError(Error);
            // return { status: 500 };
        })
}
//* Pagar extra finanzas
//* PUT /api/Purchase/item/paidOut/Extra/{idCompra}
export const putPagarCompraExtra = async ({ idCompra }) => {
    return axios.put(`${APIURL}/${urlPurchase}/item/paidOut/Extra/${idCompra}`,
        {
        },
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return getError(Error);
            // return { status: 500 };
        })
}
//* Consulta items de tipo extras (finanzas)
//* GET /api/Purchase/Extra/Authorized/{Pagina}/{Registros}
export const getItemsExtras = async ({ Pagina, Registros, Referencia }) => {
    return axios.get(`${APIURL}/${urlPurchase}/Extra/Authorized/${Pagina}/${Registros}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return {};
        })
}
//* Consulta items de tipo extra pagado (finanzas)
//* GET /api/Purchase/Extra/paidOut/{fecha}/{Pagina}/{Registros}
export const getItemsExtrasHistorico = async ({ Pagina, Registros, fecha }) => {
    return axios.get(`${APIURL}/${urlPurchase}/Extra/paidOut/${fecha}/${Pagina}/${Registros}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return {};
        })
}